import state from './bookmark.state'
import mutations from './bookmark.mutations'
import actions from './bookmark.actions'

export default {
  state,
  mutations,
  actions
}
